import React from 'react'
import TableSkeletonRows from './TableSkeletonRows'

const DataGridSkeletonOverlay = ({ rows = 8 }) => (
  <div className="w-full h-full">
    <table className="w-full border-collapse">
      <tbody>
        <TableSkeletonRows rows={rows} colSpan={1} />
      </tbody>
    </table>
  </div>
)

export default DataGridSkeletonOverlay
